import { initAll } from 'govuk-frontend'
import { onPageLoad } from '../javascript/utilities/loaders'

onPageLoad(() => {
  initAll()
})